"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHiddenElements = void 0;
const react_1 = require("react");
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_theme_1 = require("@hydrogen/elements.ui.theme");
const useHiddenElements = (targetElement, deps = []) => {
    var _a;
    const direction = (0, elements_ui_theme_1.useDirection)();
    const isRtl = direction === 'rtl';
    const [hiddenElements, setHiddenElements] = (0, react_1.useState)([]);
    const childrenWidth = (0, react_1.useRef)([]);
    const onResizeElement = () => {
        if (!targetElement.current)
            return;
        const { offsetLeft, offsetWidth } = targetElement.current;
        const fullWrapperWidth = offsetWidth + offsetLeft;
        const wrapperWidth = fullWrapperWidth > window.innerWidth
            ? offsetWidth : offsetWidth + offsetLeft;
        const hiddenChildren = childrenWidth.current.filter((a) => (a.offset >= wrapperWidth || a.offset >= window.innerWidth - offsetLeft));
        setHiddenElements(hiddenChildren);
    };
    const getChildOffsets = () => {
        var _a;
        if (!targetElement.current)
            return [];
        let offsets = !isRtl
            ? Math.max(targetElement.current.offsetLeft, 0) + 40
            : window.innerWidth
                - targetElement.current.offsetWidth - targetElement.current.offsetLeft + 40;
        const children = Array.from(((_a = targetElement.current) === null || _a === void 0 ? void 0 : _a.childNodes) || []);
        return children
            .filter((child) => child.id)
            .map((child) => {
            offsets += (0, elements_ui_utils_1.getFullWidth)(child, !!child.offsetWidth);
            return ({
                id: child.id,
                offset: offsets,
            });
        });
    };
    (0, react_1.useEffect)(() => {
        const resizeObserver = new ResizeObserver(onResizeElement);
        if (targetElement.current) {
            resizeObserver.observe(targetElement.current);
        }
        return () => {
            if (targetElement.current)
                resizeObserver.unobserve(targetElement.current);
        };
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        childrenWidth.current = getChildOffsets();
        onResizeElement();
    }, [...deps, (_a = targetElement.current) === null || _a === void 0 ? void 0 : _a.offsetLeft]);
    return hiddenElements;
};
exports.useHiddenElements = useHiddenElements;
//# sourceMappingURL=useHiddenElements.js.map